import { Routes } from '@angular/router'

import { stepModeLeaveGuard } from './step-mode.guard'

export const stepModeRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./protocol-start/protocol-start.component').then((m) => m.ProtocolStartComponent)
  },
  {
    path: 'sessions/:sessionId',
    canDeactivate: [stepModeLeaveGuard],
    loadComponent: () => import('./step-mode.component').then((m) => m.StepModeComponent)
  }
]
